module.exports = __webpack_public_path__ + "img/icon-vk-logo.1473b9cd.svg";